/**
 ** Use the following naming convention
 **
 ** VERB_PART
 **
 ** GOOD EXAMPLE: UPLOAD_COMPONENT (i.e. upload a compoennt)
 ** BAD EXAMPLE: COMPONENT_UPLOAD
 **
 ** Same goes for the definition: selfpoint/PART/CONSTANT (where CONSTANT is the left side of the definiotn, e.g. UPLOAD_COMPONENT)
 **
 ** For SUCCESS and ERROR constants you simply append it:
 **
 ** GOOD EXAMPLE: UPLOAD_COMPONENT_SUCCESS
 **/

export const INIT_APP3 = "selfpoint/App/INIT3_APP"; // Init app announcement
export const INIT_APP3_SUCCESS = "selfpoint/App/INIT3_APP_SUCCESS"; // Called if init app is success
export const INIT_APP3_FAIL = "selfpoint/App/INIT_APP3_FAIL"; //  something went wrong with the app init
export const INIT_APP3_CONNECTED = "selfpoint/App/INIT_APP3_CONNECTED"; // We have established a server connection, but INIT_APP is not done
export const INIT_APP3_READY_SERVER = "selfpoint/App/INIT_APP3_READY_SERVER"; // We have established a server connection, but INIT_APP is not done
export const INIT_APP3_READY_CLIENT = "selfpoint/App/INIT_APP3_READY_CLIENT"; // We have established a server connection, but INIT_APP is not done



export const ERROR = "selfpoint/App/ERROR"; //  global error
export const WARNING = "selfpoint/App/WARNING"; //  global warning
export const CONFIRM_WARNING = "selfpoint/App/CONFIRM_WARNING"; //  confirm/remove warning
export const DOWNLOAD3 = "selfpoint/App/DOWNLOAD3"; //  request download-token
export const REFRESH_TOKEN = "selfpoint/App/REFRESH_TOKEN"; //  refresh jwt

export const PUBSUB3_FORMDATA_UPDATE = "selfpoint/App/PUBSUB3_FORMDATA_UPDATE"; //  
export const PUBSUB3_NOTIFICATION_CREATE = "selfpoint/App/PUBSUB3_NOTIFICATION_CREATE"; //  


export const LOAD_LOCALE3 = "selfpoint/App/LOAD_LOCALE3"; //v3
export const LOAD_LOCALE3_SUCCESS = "selfpoint/App/LOAD_LOCALE3_SUCCESS"; //v3
export const SET_LOCALE3 = "selfpoint/App/SET_LOCALE3"; //v3

export const LOAD_HTMLTEMPLATES3_SUCCESS = "selfpoint/App/LOAD_HTMLTEMPLATES3_SUCCESS"; //v3



export const LOAD_CONFIGURATION3 = "selfpoint/App/LOAD_CONFIGURATION3"; //v3
export const LOAD_CONFIGURATION3_SUCCESS = "selfpoint/App/LOAD_CONFIGURATION3_SUCCESS"; //v3

export const LOAD_VIEW3 = "selfpoint/App/LOAD_VIEW3"; //v3
export const LOAD_VIEW3_SUCCESS = "selfpoint/App/LOAD_VIEW3_SUCCESS"; //v3
export const SAVE_VIEW3 = "selfpoint/App/SAVE_VIEW3"; //v3

export const LOAD_FORM3 = "selfpoint/App/LOAD_FORM3"; //v3
export const LOAD_FORM3_SUCCESS = "selfpoint/App/LOAD_FORM3_SUCCESS"; //v3
export const LOAD_FORM3_FAIL = "selfpoint/App/LOAD_FORM3_FAIL"; //v3
export const RESET_ZEROID = "selfpoint/App/RESET_ZEROID"; //v3

export const SET_FORM3_SECTION = "selfpoint/App/SET_FORM3_SECTION"; //v3
export const INC_FORM3_SECTION = "selfpoint/App/INC_FORM3_SECTION"; //v3
export const REQUEST_FORM3_SECTION = "selfpoint/App/REQUEST_FORM3_SECTION"; //v3
export const SAVE_FORM3 = "selfpoint/App/SAVE_FORM3"; //v3
export const SAVE_FORM3_SUCCESS = "selfpoint/App/SAVE_FORM3_SUCCESS"; //v3

export const REQUEST_CHANGE_STATUS3 = "selfpoint/App/REQUEST_CHANGE_STATUS3"; //v3
export const CHANGE_STATUS3 = "selfpoint/App/CHANGE_STATUS3"; //v3
export const CHANGE_STATUS3_SUCCESS = "selfpoint/App/CHANGE_STATUS3_SUCCESS"; //v3
export const ADD_NOTE3 = "selfpoint/App/ADD_NOTE3"; //v3
export const UPLOADv3 = "selfpoint/App/UPLOAD3"; //v3
export const UNLOAD_FORM3 = "selfpoint/App/UNLOAD_FORM3"; //v3

export const LOAD_DATASET_V3 = "selfpoint/App/LOAD_DATASET_V3" 
export const LOAD_DATASET_V3_SUCCESS = "selfpoint/App/LOAD_DATASET_V3_SUCCESS" 
export const UNLOAD_DATASET_V3 = "selfpoint/App/UNLOAD_DATASET_V3" 

export const DISPATCH_EVENT3 = "selfpoint/App/DISPATCH_EVENT3" 
export const DISPATCH_EVENT3_SUCCESS = "selfpoint/App/DISPATCH_EVENT3_SUCCESS" 
export const SUBSCRIBE3 = "selfpoint/App/SUBSCRIBE3" 
export const PUB3 = "selfpoint/App/PUB3" 
export const PUB3_CLEAR = "selfpoint/App/PUB3_CLEAR" 
export const PUB3_CONFIRM = "selfpoint/App/PUB3_CONFIRM" 


export const RUN_EFFECT_V3 = "selfpoint/App/RUN_EFFECT_V3" 
export const RUN_EFFECT_V3_SUCCESS = "selfpoint/App/RUN_EFFECT_V3_SUCCESS" 
export const UNLOAD_EFFECT_V3 = "selfpoint/App/UNLOAD_EFFECT_V3" 

export const SERVER_REQUEST = "selfpoint/Socket/SERVER_REQUEST"; // Pass a server request via socket.io

export const LOGIN3 = "selfpoint/App/LOGIN3";
export const LOGIN3_SUCCESS = "selfpoint/App/LOGIN3_SUCCESS";
export const LOGIN3_FAILED = "selfpoint/App/LOGIN3_FAILED";
export const LOGIN3_SESSION = "selfpoint/App/LOGIN3_SESSION";
export const LOGIN3_METADATA = "selfpoint/App/LOGIN3_METADATA";

export const COLLECT3 = "selfpoint/App/COLLECT3";
export const CANCEL_LOGIN = "selfpoint/App/CANCEL_LOGIN"

export const RECONNECT3 = "selfpoint/App/RECONNECT3" 
export const RECONNECT3_SUCCESS = "selfpoint/App/RECONNECT3_SUCCESS" 

export const VALIDATION_ERROR = "selfpoint/App/VALIDATION_ERROR" 
export const SET_VALIDATION_MESSAGE3 = "selfpoint/App/SET_VALIDATION_MESSAGE3" 
export const CONFIRM_VALIDATION_MESSAGE3 = "selfpoint/App/CONFIRM_VALIDATION_MESSAGE3" 

export const FORM_CLOSE3 = "selfpoint/App/FORM_CLOSE3" 

export const STOP3 = "selfpoint/App/STOP3" 

// user
export const SET_USER_PERSISTENT_PROFILE3 = "selfpoint/App/SET_USER_PERSISTENT_PROFILE3" 
export const UPDATE_USER_ATTRIBUTES3 = "selfpoint/App/UPDATE_USER_ATTRIBUTES3" 

// uploads
export const INIT_UPLOADv3 = "selfpoint/App/INIT_UPLOADv3" 
export const INIT_UPLOADv3_SUCCESS = "selfpoint/App/INIT_UPLOADv3_SUCCESS" 
export const STREAM_UPLOADv3 = "selfpoint/App/STREAM_UPLOADv3" 
export const STREAM_UPLOAD_v3_SUCCESS = "selfpoint/App/STREAM_UPLOAD_v3_SUCCESS" 
export const FINISH_UPLOADv3 = "selfpoint/App/FINISH_UPLOADv3" 
export const REMOVE_UPLOADv3 = "selfpoint/App/REMOVE_UPLOADv3" 
export const REMOVE_UPLOAD_v3_SUCCESS = "selfpoint/App/REMOVE_UPLOAD_v3_SUCCESS" 
